<template>
  <div style="height:42px;margin:0 auto;">
    <template v-if="!clicable">
      <div @click="clicable = true" v-bind:style="{textAlign: (isNumber?'right':''),  width: inputWidth || '70px'}" style="text-decoration:underline;cursor:pointer;float:left;line-height:40px;font-size:14px;height:40px;">{{val}}</div>
    </template>
    <template v-else>
      <input type="text" class="compinput" v-model="nValue" v-bind:style="{width: inputWidth || '70px'}" v-bind:class="{number: isNumber}" style="float:left; text-align:center;padding-right:5px;padding-left:5px;" />
      <div style="cursor:pointer;" @click="cancel()" ><img src="/img/ban-solid.png" style="cursor:pointer;width:20px;height:20px;margin:0 5px;fill:#ff0000;float:left;"  /></div>
      <div style="cursor:pointer;" @click="clicked" ><img src="/img/save-regular.png" style="cursor:pointer;width:20px;height:20px;margin:0 5px;fill:#00ff00;float:left;margin-top:24px;margin-left:-24px;" /></div>
    </template>
  </div>
</template>

<script>
import formaters from '@/mixins/formater'

export default {
  name: 'OpaContentEditable',
  data () {
    return {
      clicable: false,
      oldValue: null
    }
  },
  props: [
    'value',
    'type',
    'decimal',
    'inputWidth'
  ],
  mixins: [formaters],

  mounted () {
    this.oldValue = this.value
    this.nValue = this.value
  },

  computed: {

    val: {
      get () {
        if (this.type === 'number') {
          return this.formatPrice(this.value, this.decimal)
        } else {
          return this.value
        }
      }
    },

    isNumber () {
      return this.type === 'number'
    }
  },

  methods: {
    clicked () {
      // console.log('nvalue', this.nValue)
      this.clicable = false
      this.oldValue = this.nValue
      this.$emit('click', this.nValue)
    },

    cancel () {
      this.nValue = this.oldValue
      this.clicable = false
    }
  }
}
</script>

<style lang="scss" scoped>
.compinput {
  height: 40px;
  width:60px;
  border-radius: 4px;
  background-color: #FFFFFF;
  border: 0px;
  color: #423D4E;
  font-family: Roboto;
  font-size: 14px;
}

.number {
  text-align:right;
}
</style>
